__turbopack_context__.v({
  "darkTheme": "npc-grid-selector-module__Qf5KAW__darkTheme",
  "disabled": "npc-grid-selector-module__Qf5KAW__disabled",
  "emptyContainer": "npc-grid-selector-module__Qf5KAW__emptyContainer",
  "loadingContainer": "npc-grid-selector-module__Qf5KAW__loadingContainer",
  "npcCard": "npc-grid-selector-module__Qf5KAW__npcCard",
  "npcGrid": "npc-grid-selector-module__Qf5KAW__npcGrid",
  "npcGridSelector": "npc-grid-selector-module__Qf5KAW__npcGridSelector",
  "npcImage": "npc-grid-selector-module__Qf5KAW__npcImage",
  "npcInfo": "npc-grid-selector-module__Qf5KAW__npcInfo",
  "npcName": "npc-grid-selector-module__Qf5KAW__npcName",
  "placeholderIcon": "npc-grid-selector-module__Qf5KAW__placeholderIcon",
  "placeholderImage": "npc-grid-selector-module__Qf5KAW__placeholderImage",
  "previewImage": "npc-grid-selector-module__Qf5KAW__previewImage",
  "selected": "npc-grid-selector-module__Qf5KAW__selected",
});
